import { type FunctionComponent, type ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import styles from './styles/LoginSuspendedAccountErrorMessage.scss';

const LoginSuspendedAccountErrorMessage: FunctionComponent = () => (
    <FormattedMessage
        id="login.message.suspended_account_error"
        defaultMessage="Your account has been suspended. For more information, contact <a>support@1stdibs.com</a>"
        values={{
            a: (content: ReactNode[]) => (
                <Link target="_blank" href="mailto:support@1stdibs.com" className={styles.link}>
                    {content}
                </Link>
            ),
        }}
    />
);

export { LoginSuspendedAccountErrorMessage };
